import { forwardRef } from "react";
import { ThemeType, useTheme } from "@/mds/themes/theme-context";
import type { MDSThemedImageProps } from "./themed-image.types";

export const MDSThemedImage = forwardRef<HTMLImageElement, MDSThemedImageProps>(
  ({ darkSrc, darkSrcSet, lightSrc, lightSrcSet, alt, ...imageProps }, ref) => {
    const { themeType } = useTheme();
    const isDarkTheme = themeType === ThemeType.HarvestMoon;

    return (
      <img
        {...imageProps}
        ref={ref}
        data-mds-name="themed-image"
        src={isDarkTheme ? darkSrc : lightSrc}
        srcSet={isDarkTheme ? darkSrcSet : lightSrcSet}
        alt={alt}
      />
    );
  }
);

MDSThemedImage.displayName = "MDSThemedImage";
